import { Injectable }    from '@angular/core';
import { Observable }    from 'rxjs';

import { Doctor } from '../../classes/doctor';

import { Auth } from '../auth.service';
import { RequestService } from '../request.service';
import { UserService } from '../users/user.service';

import * as _ from 'lodash';

@Injectable()
export class DoctorService extends UserService {

  constructor(
    protected requestService: RequestService,
    protected auth: Auth
  ) { super(requestService, auth); }

  protected getUsersUrl(): string {

    return 'doctors';
  };

  protected getOneUserUrl(): string {

    return 'doctor';
  };

  protected parseObject(obj: any): Doctor {

    return obj as Doctor;
  };

  protected parseArray(objs: any): Doctor[] {

    return objs as Doctor[];
  };

  search(terms: any): Observable<any[]> {

    let urlQueryParams: any = {};

    if (_.has(terms, 'name')) {

      urlQueryParams.name = terms.name;
    }

    return this.requestService.makeRequest({
      urlKey: this.getUsersUrl(),
      urlQueryParams: urlQueryParams,
      asObservable: true
    })
      .map((res: any) => this.parseArray(res.json()));
  }

  getAll(): Promise<any> {
    return this.requestService.makeRequest(
      {
        method: 'get',
        urlQueryParams: {
          limit:1000
        }
      }, '/doctor').then((response: any) => response.json() as any);
  };

  addLanguage(id:string, languageId:string): Promise<any> {
    return this.requestService.makeRequest({
      urlKey:'updateDoctorLanguage',
      method:'put',
      urlParams:{
        id:id,
        languageId:languageId
      }
    })
  }

  removeLanguage(id:string, languageId:string): Promise<any> {
    return this.requestService.makeRequest({
      urlKey:'updateDoctorLanguage',
      method:'delete',
      urlParams:{
        id:id,
        languageId:languageId
      }
    })
  }

  getStatus(params): Promise<any>{
    return this.requestService.makeRequest({
      urlKey:'doctorStatus',
      method: 'get',
      urlQueryParams: params
    }).then((response:any)=>{return response.json()})
  }

  saveMedikitData(id:string, body:any): Promise<any> {
    return this.requestService.makeRequest({
      urlKey:'saveMedikitData',
      method:'put',
      urlParams:{
        id:id
      },
      body: JSON.stringify(body)
    })
  }

  sendReportToLadDoctors(params): Promise<any>{
    return this.requestService.makeRequest({
      urlKey:'sendReportToLadDoctors',
      method: 'get',
      urlQueryParams: params
    }).then((response:any)=>{return response.json()})
  }

  setDoctorBannedStatus(doctorId: string, banned: boolean, needsUnban: boolean): Promise<any> {
    const params = { doctorId: doctorId, banned: banned, needsUnban: needsUnban };

    return this.requestService.makeRequest({
      urlKey: "setDoctorBannedStatus",
      method: "put",
      urlParams:{
        id:doctorId,
      },
      body: JSON.stringify(params)
    })
    .then((response: any) => this.parseObject(response.json()));
  }
}



// WEBPACK FOOTER //
// ./src/app/services/doctors/doctor.service.ts